import { type FunctionalComponent, getAssetPath, h } from '@stencil/core';

export interface IMAdeInAmericaBadge {
  isActive: boolean;
  isGridView: boolean;
}

export const MadeInAmericaBadge: FunctionalComponent<IMAdeInAmericaBadge> = (
  props,
) => {
    const variant = props.isGridView ? 'grid' : 'list';
    const buildClass = `made-in-america-badge--${variant}-variant`;

    return props.isActive ? (
      <img
        class={`made-in-america-badge ${buildClass}`}
        src={getAssetPath('./assets/png/MiA_Logo.png')}
        alt='Made In America Logo'
        loading="lazy"
      />
    ) : (
      ''
    );
};
